import React, { Component } from 'react';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import AboutUs from '../../components/AboutUs';
import IconBox from '../../components/IconBox';
import Registrationdetails from './../../components/Registrationdetails';
import TestimonialSlider from '../../components/TestimonialSlider';
import FaqEvent from '../../components/FaqEvent';
import Footer from '../../components/Footer';
import { Styles } from "./styles/registration.js";

class Registration extends Component {

    render() {
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper register-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title="Registrations" />

                    {/* About Area */}
                    {/* <AboutUs /> */}

                    {/* Icon Box Area */}
                    {/* <IconBox /> */}

                    {/* Tab Section */}
                    <Registrationdetails />

                    {/* Testimonial Slider */}
                    {/* <TestimonialSlider /> */}

                    {/* Faq & Event Area */}
                    {/* <FaqEvent /> */}

                    {/* Footer 2 */}
                    <Footer />

                </div>
            </Styles>
        )
    }
}

export default Registration